import React, { Component } from 'react'
import { message, Icon } from 'antd'

export default class extends Component {
  state = {
    validated: true,
    percent: 0
  }

  upload = () => {
    const { uploadFile, file } = this.props

    if (uploadFile) {
      uploadFile(file, this.onProgress).then(response => {
        if (response.data.error !== null) {
          message.error(response.data.error.message)
          this.setState({ validated: false })
        }
      })
    }
  }

  onProgress = (percent) => {
    this.setState({
      percent: percent
    })
  }

  validate = () => {
    const { file } = this.props
    const isLt2GB = file.size / 1024 / 1024 < 200
    if (!isLt2GB) {
      this.setState({
        validated: false
      })
      message.error('File must be smaller than 200Mb!')
      return false
    }
    return true
  }

  componentDidMount () {
    if (this.validate()) {
      setTimeout(this.upload, 100)
    }
  }

  render () {
    const { file } = this.props
    const { percent, validated } = this.state

    if (!validated) {
      return <div className='file-uploader'>
        <div className='file-uploader__inner'>
          <div className='file-uploader__part'>
            <div className={'file-uploader__name file-uploader__name_invalid'}>
              { file.name }
            </div>
          </div>
        </div>
      </div>
    }

    return (
      <div className='file-uploader'>
        <div className='file-uploader__inner'>
          <div className='file-uploader__part'>
            <div className='file-uploader__loading'>
              <Icon type='loading' />
            </div>
            <div className={'file-uploader__name'}>
              { file.name }
            </div>
          </div>
          <div className='file-uploader__part'>
            { percent + '%' }
          </div>
        </div>
        <div className='file-uploader__progress' style={{ width: percent + '%' }} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/components/FileUploader/FileUploader.jsx